
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 40 40"}},[_c('path',{attrs:{"d":"M21.533 7.616v-5.22a.088.088 0 00-.095-.063h-4.031c-.048 0-.072.027-.072.063v5.22a11.507 11.507 0 01-.786 4.045h5.75a11.584 11.584 0 01-.766-4.045zm3.355 11.202l-2.41-5.882h-6.027l-2.446 5.883a15.005 15.005 0 00-1.137 5.707v12.2a.939.939 0 00.928.847h11.337a.871.871 0 00.857-.847v-12.2a15.219 15.219 0 00-1.102-5.708z"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      